import React from "react";
var Header = function (props) {
    return (React.createElement("div", { className: "verified-client-header" },
        React.createElement("p", { className: "DMSansMedium_15_500 text-white ".concat(props.titleClassName ? props.titleClassName : "") }, props.title),
        React.createElement("p", { className: "txt_blue-light3 DMSanN_14_300 fw-light ".concat(props.subTextClassName ? props.subTextClassName : "") }, props.subText)));
};
export default Header;
